export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="8" fill="#071330" />
    <path d="M8.5 15.5 20 8.5l11.5 7" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M20 10.6v4.6M18.2 12.4h3.6" stroke="#C5A059" strokeWidth="1.5" strokeLinecap="round" />
    <rect x="10.5" y="18" width="3.4" height="10.5" fill="#fff" />
    <rect x="18.3" y="18" width="3.4" height="10.5" fill="#fff" />
    <rect x="26.1" y="18" width="3.4" height="10.5" fill="#fff" />
    <path d="M8.5 31h23" stroke="#fff" strokeWidth="1.8" />
    <path d="M10.5 33.6h19" stroke="#C5A059" strokeWidth="1" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className={`h-9 w-9 ${light ? "ring-1 ring-white/20 rounded-lg" : ""}`} />
    <span className={`font-display text-2xl font-semibold leading-none tracking-tight ${light ? "text-white" : "text-navy"}`}>
      Grace Treasury
    </span>
  </span>
);
